import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { UrgencyModel } from './model';
import { UrgencyState } from './state';
import * as selectors from './selectors';
import * as actions from './actions';
import { UserFacade } from '../user/facade';

@Injectable()
export class UrgencyFacade {
  private store = inject<Store<UrgencyState>>(Store);
  private userFacade = inject(UserFacade);

  allUrgencies$ = this.store.pipe(select(selectors.selectAll));

  constructor() {
    this.getAll();
  }

  public getAll() {
    this.userFacade.selected().subscribe(user => {
      if (user) {
        this.store.dispatch(new actions.LoadRequestAction());
      }
    });
  }

  getById(id: number): Observable<UrgencyModel> {
    return this.store.pipe(select(selectors.selectById(id)));
  }

  getError(): Observable<any> {
    return this.store.pipe(select(selectors.selectError));
  }

  isLoading(): Observable<boolean> {
    return this.store.pipe(select(selectors.selectIsLoading));
  }
}
